export function calculaVariacao(valor: number, valor2: number): number {
  if (valor2 > 0) {
    return (100 * valor) / valor2 - 100;
  }
  if (valor === 0 || valor2 === 0) {
    return 100;
  }
  return 0;
}
